/** 控制台 — 空调设备 /device/conditioning（conditioning.vue） */
export default {
  deviceConditioning: {
    tabNavAria: '空调模块切换',
    tabIndoor: '空调内机',
    tabOutdoor: '空调拓扑图',

    phDeviceName: '设备名称',
    phTenant: '租户名称/编号',
    phOnlineStatus: '在线状态',
    phPowerStatus: '空调开启状态',
    all: '全部',
    online: '在线',
    offline: '离线',
    btnSearch: '查询',
    btnReset: '重置',
    btnExport: '导出',
    exportCurrentPage: '导出本页',
    exportSelected: '导出选中',
    exportAll: '导出全部',
    sectionIndoorCard: '空调内机卡片',
    sectionIndoorList: '空调内机列表',
    batchAction: '批量操作',
    batchControl: '批量控制',
    batchLock: '批量锁定',
    batchUnlock: '批量解锁',
    batchTiming: '批量定时',
    viewTimingTasks: '查看定时任务',
    sortDefault: '默认排序',
    viewList: '列表',
    viewCard: '卡片',
    selectedCount: '{count} selected',
    selPrefix: '已选择 ',
    selSuffix: ' 条数据',
    copySerialTip: '点击可复制',
    bindDedicated: '专用',
    bindPublic: '公摊',
    colIndoorSerial: '设备序列号',
    colDeviceName: '设备名称',
    colDeviceType: '设备类型',
    colBindShareType: '公摊类型',
    colBindInfo: '绑定信息',
    colOutdoorSystemName: '空调外机系统名称',
    colSwitch: '开关',
    colMode: '模式',
    colTemp: '温度(℃)',
    colFanSpeed: '风速',
    colFault: '故障状态',
    colLastReportTime: '空调最新上报时间',
    colSerialShort: '序列号',
    colId: 'Id',
    colOp: '操作',
    control: '控制',
    unlock: '解锁',
    lock: '锁定',
    dialogTip: '提示',
    dialogConfirm: '确定',
    dialogCancel: '取消',
    confirmUnlockSingle: '确认解锁空调？',
    confirmUnlockBatch: '确认批量解锁 {count} 台空调？',
    cardLockedHint: '已锁定',
    more: '更多',
    opTiming: '定时',
    opEdit: '编辑',
    opDetail: '详情',
    opHistory: '控制历史',
    unbound: '未绑定',
    faultNormal: '正常',
    faultOffline: '离线',
    cardSerialLabel: '序列号：',
    setTemp: '设置温度',
    indoorTemp: '室内温度',
    switchBtn: '开关',
    modeBtn: '模式',
    fanBtn: '风速',

    outdoorPhSystem: '请选择外机系统',
    outdoorUnnamed: '未命名',
    colGwMac: '网关MAC',
    colOutdoorName: '外机系统名称',
    colTariffPlan: '计费方案',
    colMeterDev: '计量设备',
    colIndoorUnits: '空调内机',
    priceSharp: '尖电价',
    pricePeak: '峰电价',
    priceFlat: '平电价',
    priceValley: '谷电价',
    view: '查看',
    bindElectricTariff: '绑定电费方案',

    relationTitle: '关系图',
    nodeListTitle: '节点列表',
    nodeListTitleWithParent: '{name} 节点列表',
    phSearchNameSerial: '搜索名称/序列号',
    emptyNoData: '暂无数据',

    dialogEditDevice: '编辑设备',
    labelDeviceSerial: '设备序列号',
    labelDeviceName: '设备名称',
    labelDeviceType: '设备类型',
    labelShareType: '公摊类型',
    labelRemark: '备注信息',
    phDeviceSerial: '请输入设备序列号',
    phDeviceName: '请输入设备名称',
    phSelectDeviceType: '请选择设备类型',
    phSelectShareType: '请选择公摊类型',
    phRemark: '请输入备注信息',
    btnCancel: '取 消',
    btnConfirm: '确 定',
    saving: '保存中...',

    ruleIndoorSerial: '请输入设备序列号',
    ruleDeviceName: '请输入设备名称',
    ruleDeviceType: '请选择设备类型',
    ruleBindType: '请选择公摊类型',

    currentProject: '当前项目',

    enumVrf: '多联机',
    enumDedicated: '专用',
    enumPublic: '公摊',
    enumPowerOff: '关闭',
    enumPowerOn: '开启',
    enumModeAuto: '自动',
    enumModeHeat: '制热',
    enumModeCool: '制冷',
    enumModeFan: '送风',
    enumModeDry: '除湿',
    enumFanAuto: '自动',
    enumFanLow: '低风',
    enumFanMid: '中风',
    enumFanHigh: '高风',
    enumLockNone: '不锁定',
    enumLockPowerOff: '关机',
    enumLockPowerOn: '开机',
    enumLogSwitch: '开关',
    enumLogMode: '模式',
    enumLogLock: '锁定',
    enumWeekMon: '周一',
    enumWeekTue: '周二',
    enumWeekWed: '周三',
    enumWeekThu: '周四',
    enumWeekFri: '周五',
    enumWeekSat: '周六',
    enumWeekSun: '周日',

    logUnlock: '解锁',
    tagAcPowerOn: '开机',
    tagAcPowerOff: '关机',
    acDrawerTitle: '详情',
    acDrawerLabelSerial: '设备序列号',
    acDrawerLabelId: '编号',
    acDrawerLabelType: '设备类型',
    acDrawerLabelCreateTime: '创建时间',
    acDrawerLabelDataUpdate: '数据更新',
    acDrawerLabelGateway: '所属网关',
    acDrawerBindTitle: '已绑信息',
    acDrawerNoBind: '暂无绑定信息',
    acDrawerMeterTitle: '计量电表',
    acDrawerNoMeter: '暂无计量电表',
    acDrawerMetricSetTemp: '设置温度/℃',
    acDrawerMetricRoomTemp: '室内温度/℃',
    acDrawerMetricMode: '运行模式',
    acDrawerMetricFan: '风速档位',
    acDrawerHistoryTitle: '控制历史',
    acDrawerViewTable: '表格',
    acDrawerViewChart: '图表',
    acDrawerColTime: '操作时间',
    acDrawerColSource: '操作来源',
    acDrawerColType: '操作类型',
    acDrawerColContent: '操作内容',
    acDrawerColResult: '操作结果',
    acDrawerSourceDevice: '设备上报',
    acDrawerSourceUser: '用户下发',
    acDrawerResultOk: '成功',
    acDrawerResultFail: '失败',
    acDrawerEmptyHistory: '暂无控制历史',
    acDrawerChartSeriesType: '操作类型',
    acDrawerEnergyTitle: '设备用能统计',
    acDrawerEnergyReport: '查看详细报表',
    acDrawerDateStart: '开始日期',
    acDrawerDateEnd: '结束日期',
    acDrawerColDate: '日期',
    acDrawerFanHigh: '高风速',
    acDrawerFanMid: '中风速',
    acDrawerFanLow: '低风速',
    acDrawerFanAuto: '自动风',
    acDrawerColDuration: '时长(小时)',
    acDrawerColKwh: '电量(度)',
    acDrawerColTotalHours: '总时长(h)',
    acDrawerColTotalKwh: '总电量(度)',
    acDrawerColSysTotalKwh: '系统总电量(度)',
    acDrawerEmptyEnergy: '暂无用能统计数据',
    acDrawerTopologyTitle: '空调拓扑',
    acDrawerEmptyRelation: '暂无关联设备',
    acDrawerErrLoad: '加载数据失败',
    acDrawerWarnMeterSerial: '电表序列号无效',

    topoHint: '拖拽画布移动视图 · 滚轮缩放查看全局拓扑',
    topoRefresh: '刷新',
    topoVertical: '纵向',
    topoHorizontal: '横向',
    topoZoomOut: '缩小',
    topoZoomIn: '放大',
    topoFocusRoot: '定位根节点',
    topoFocusSelected: '定位选中节点',
    topoResetView: '重置视图',
    topoEmptyData: '暂无拓展图数据',
    treeSetTemp: '设置温度',
    treeRoomTemp: '室内温度',
    treeExpand: '展开',
    treeCollapse: '折叠',
    treeExpandN: '展开 {n} 个节点',
    treeAltNode: '节点',

    warnNothingToCopy: '无可复制内容',
    successSerialCopied: '序列号已复制',
    errCopy: '复制失败',
    errOutdoorFetch: '获取外机数据失败',
    warnNoMeterForOutdoor: '该外机系统暂无关联电表',

    warnNoExportData: '暂无数据可导出',
    warnNoSelectedExport: '请先勾选要导出的数据',
    successExported: '成功导出 {count} 条数据',
    successExportedLimit: '共 {total} 条，已导出前 {count} 条',
    errExport: '导出失败',
    exporting: '正在导出...',
    exportSheetName: '空调内机',
    exportFilePrefix: '空调内机'
  }
}
